import { CLEAR_CREATE_DATA } from 'ACTIONS';

export const clearCreateData = () => (dispatch) => {
    dispatch({ type: CLEAR_CREATE_DATA });
};
